import * as S from './style';
import useIsMobile from '@/hooks/useIsMobile';
import { useState } from 'react';
import { useGetPayInfoApi } from '@/api/payment';
import dayjs from 'dayjs';
import { convertPaymentValue } from '@/utils/convertValue';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import ModalBox from '@/components/common/Modal/ModalBox/ModalBox';
import PaymentModal from '@/components/common/Modal/PaymentModal/PaymentModal';
import { downloadPdf } from '@/utils/fileUtils';
const MembershipPayment = () => {
	const isMobile = useIsMobile(900);
	const today = dayjs().format('YYYY');
	const [isOpen, setIsOpen] = useState(false);

	const { data: payInfo } = useGetPayInfoApi();

	const onClickPayment = () => {
		setIsOpen(true);
	};

	return (
		<S.Container>
			<S.Title>
				학회 연회비 납부내역
				<S.PaymentButton disabled={!!payInfo?.pay_info[0]?.pay_info_pk} onClick={onClickPayment}>
					납부하기
				</S.PaymentButton>
			</S.Title>
			<>
				{!isMobile && (
					<S.Table>
						<S.TableHead>
							<S.TableRow>
								<S.TableHeadCell>년도</S.TableHeadCell>
								<S.TableHeadCell>연회비</S.TableHeadCell>
								<S.TableHeadCell>지불방법</S.TableHeadCell>
								<S.TableHeadCell>납부일</S.TableHeadCell>
								<S.TableHeadCell>납부</S.TableHeadCell>
							</S.TableRow>
						</S.TableHead>
						<S.TableBody>
							{payInfo &&
								payInfo.pay_info.map((info, index) => (
									<S.TableRow key={index}>
										<S.TableCell>{info.pay_info_pk ? dayjs(info.pay_info_tran_date).format('YYYY') : today}</S.TableCell>
										<S.PointCel>
											{info.pay_info_pk
												? `₩
												${
													info.pay_info_amt
														? `${info.pay_info_amt.toLocaleString()} ${info.pay_info_member_type ? `(${info.pay_info_member_type})` : ''}`
														: convertPaymentValue(payInfo.member_type)
												}`
												: '-'}
										</S.PointCel>
										<S.TableCell>{info.pay_info_pay_method ? info.pay_info_pay_method : '-'}</S.TableCell>
										<S.TableCell>{info.pay_info_pk ? dayjs(info.pay_info_tran_date).format('YYYY-MM-DD') : '-'}</S.TableCell>
										<S.TableCell>
											{info.pay_info_pk ? (
												<>
													<S.TableCellSuceess>납부완료</S.TableCellSuceess>
													<S.CompleteStatus type="button" onClick={() => downloadPdf(info.pay_info_pk ?? '')}>
														영수증 확인
													</S.CompleteStatus>
												</>
											) : (
												<S.TableCellDanger>미납</S.TableCellDanger>
											)}
										</S.TableCell>
									</S.TableRow>
								))}
						</S.TableBody>
					</S.Table>
				)}
				{isMobile &&
					payInfo &&
					payInfo.pay_info.map((info, index) => (
						<S.MobileCard key={index}>
							<S.CardContentBox>
								<S.MenuBox>
									<S.CardMenu>년도</S.CardMenu>
									<div>{info.pay_info_pk ? dayjs(info.pay_info_tran_date).format('YYYY') : today}</div>
								</S.MenuBox>
								<S.MenuBox>
									<S.CardMenu>연회비</S.CardMenu>
									<S.PointMenu>
										₩
										{info.pay_info_amt
											? `${info.pay_info_amt.toLocaleString()} ${info.pay_info_member_type ? `(${info.pay_info_member_type})` : ''}`
											: convertPaymentValue(payInfo.member_type)}
									</S.PointMenu>
								</S.MenuBox>
								<S.MenuBox>
									<S.CardMenu>지불방법</S.CardMenu>
									<div>{info.pay_info_pay_method ? info.pay_info_pay_method : '-'}</div>
								</S.MenuBox>
								<S.MenuBox>
									<S.CardMenu>납부일</S.CardMenu>
									<div>{info.pay_info_pk ? dayjs(info.pay_info_tran_date).format('YYYY-MM-DD') : '-'}</div>
								</S.MenuBox>
								<S.MenuBox>
									<S.CardMenu>납부</S.CardMenu>
									<div>{info.pay_info_pk ? <S.TableCellSuceess>납부완료</S.TableCellSuceess> : <S.TableCellDanger>미납</S.TableCellDanger>}</div>
								</S.MenuBox>
							</S.CardContentBox>
							{info.pay_info_pk ? (
								<S.Button type="button" onClick={() => downloadPdf(info.pay_info_pk ?? '')}>
									영수증 확인
								</S.Button>
							) : (
								<></>
							)}
						</S.MobileCard>
					))}

				{isOpen && payInfo && (
					<ModalPortal>
						<ModalBox onClick={() => setIsOpen(false)}>
							<PaymentModal closeModal={setIsOpen} goodsName="연회비" />
						</ModalBox>
					</ModalPortal>
				)}
			</>
		</S.Container>
	);
};
export default MembershipPayment;
